import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { JSPCampaign, JSPPackage } from 'src/app/models/jsp-package';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'journey-select-plus-card',
  templateUrl: './journey-select-plus-card.component.html',
  styleUrls: ['./journey-select-plus-card.component.scss'],
})
export class JourneySelectPlusCardComponent implements OnInit, OnChanges {
  @Input() data: JSPPackage;
  @Input() ctaLabel: string;
  @Input() ctaRoute = '/jsp/search';
  @Input() loading = false;

  public tierNameLead = '';
  public tierNameHighlight = '';

  constructor(
    private navControl: NavController,
    private analyticsService: AnalyticsService,
    private translate: TranslateService
  ) {
    this.ctaLabel = this.translate.instant(
      'flight.jsp_search.explore_my_pack'
    );
  }

  ngOnInit() {
    this.splitTierName();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.splitTierName();
    }
  }

  exploreCTA() {
    this.analyticsService.trackEvent('button_clicked', {
      component: 'journey-select-plus-card',
      button: this.ctaLabel,
    });
    if (this.ctaRoute) {
      this.navControl.navigateForward([this.ctaRoute]);
    }
  }

  trackByCampaign(index: number, campaign: JSPCampaign) {
    return campaign?.id ?? campaign?.title ?? index;
  }

  onIconError(event: Event) {
    const target = event.target as HTMLImageElement;
    if (target) {
      target.style.display = 'none';
    }
  }

  private splitTierName() {
    const tierName = (this.data?.tierName || '').trim();
    if (!tierName) {
      this.tierNameLead = '';
      this.tierNameHighlight = '';
      return;
    }
    const parts = tierName.split(/\s+/);
    if (parts.length === 1) {
      this.tierNameLead = '';
      this.tierNameHighlight = parts[0];
    } else {
      this.tierNameHighlight = parts.pop() as string;
      this.tierNameLead = parts.join(' ');
    }
  }
}
